import { render, staticRenderFns } from "./SalesforceView.vue?vue&type=template&id=0e6061d6&scoped=true"
import script from "./SalesforceView.vue?vue&type=script&lang=ts"
export * from "./SalesforceView.vue?vue&type=script&lang=ts"
import style0 from "./SalesforceView.vue?vue&type=style&index=0&id=0e6061d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6061d6",
  null
  
)

export default component.exports